<template>
  <div>
    <!--打款列表 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>打款列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card style="margin-top:20px">
      <div>
        <el-row class="conentRow">
          <el-input placeholder="请输入账号" v-model="data.number"></el-input>
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <el-button class="conentBtn" type="primary" @click="chaBtns">查询</el-button>
        </el-row>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column prop="remit_date" label="打款日期"></el-table-column>
          <el-table-column prop="money" label="打款金额(元)"></el-table-column>
          <el-table-column prop="number" label="收款账号"></el-table-column>
          <el-table-column prop="remitstatus" label="打款状态">
            <template slot-scope="scope">
              <img src="@/images/distributor/dh.png" alt v-if="scope.row.remitstatus=='1'"/>
              <img src="@/images/distributor/dl.png" alt v-if="scope.row.remitstatus=='2'" />
              <span style="margin-left:10px">{{scope.row.remitstatus=='1'?'未打款':'已打款'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="凭证">
            <template slot-scope="scope">
              <img
                style="width:50px;height:36px; vertical-align: middle;"
                :src="scope.row.url"
                alt
                @click="voucherFn(scope.row)"
              />
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total"  :current-page.sync="data.page"  @current-change="currenchange"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
    </el-card>
    <!-- 凭证开始 -->
    <!-- <sellStaDialog v-if="refundTicketvisible" ref="refundTicketDialog"></sellStaDialog> -->
    <!-- 凭证结束 -->
    <div class="fixed" v-if="vouchervisible">
        <div class="fixed_box">
            <div class="box_tit">
                <span>凭证</span>
                <img src="@/images/distributor/Grou.png" alt="" @click="vouchervisible=false">
            </div>
            <div class="box_imgs">
              <img :src="imgs" alt="">
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// import sellStaDialog from "./dialog/sellStaDialog.vue";

import {getInfoRemitList} from '@/request/distributor.js'
export default {
  components: {
    // sellStaDialog
  },
  data() {
    return {
      vouchervisible: false, // 凭证
      tableData: [
      ],
      value: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: "",
      data:{
        token:window.sessionStorage.getItem('Token'),
        number:"",
        start_time:"",
        end_time:"",
        page:1,
        page_size:8
      },
      total:0,
      imgs:""
    };
  },
  created(){
    this.getList()
  },
  methods: {
    getList(){
      getInfoRemitList(this.data).then(res=>{
        console.log(res)
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },
    currenchange(e){
      this.data.page = e
      this.getList()
    },
    chaBtns(){
      this.data.page = 1
      if(this.value1){
        this.data.start_time = this.value1[0] + ' 00:00:00'
        this.data.end_time = this.value1[1] + ' 23:59:59'
        this.getList()
      }else{
        this.data.start_time = ''
        this.data.end_time = ''
        this.getList()
      }
    },
    // 凭证明细
    voucherFn(row) {
      this.imgs = row.url
      this.vouchervisible = true;
      // this.$nextTick(() => {
      //   this.$refs.voucherDialog.voucher(row);
      // });
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.titleSear {
  margin-bottom: 20px;
  .el-input {
    width: 300px;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
    margin-left: 20px;
  }
}
.conentRow {
  display: flex;
  margin-bottom: 20px;
  .el-date-editor {
    margin-right: 20px;
  }
  .el-input {
    width: 250px;
    margin-right: 20px;
  }
  .conentBtn {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    border: none;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
}

.fixed{
  position: fixed;
  background: rgba(0, 0, 0, .7);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  .fixed_box{
    width: 132rem;
    border-radius: .4rem;
    background: #fff;
    padding: 0 2rem 2rem 2rem;
    .box_tit{
      padding: 2.4rem 0;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      border-bottom: 1px solid #E5E5EA;
      span{
        font-size: 2rem;
        color: #000;
        font-weight: 600;
      }
      img{
        position: absolute;
        right: 2rem;
        cursor: pointer;
      }
    }
    .box_imgs{
      width:128rem;
      height: 66.2rem;
      margin-top: 2rem;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
}
.cell img{
  cursor: pointer;
}
// /deep/.el-dialog__header {
//   height: 60px;
//   line-height: 60px;
//   padding: 0;
// }

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 45px auto 40px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
/deep/.el-table__footer-wrapper tbody td.el-table__cell,
.el-table__header-wrapper tbody td.el-table__cell {
  background-color: #f5f7fa;
  color: #606266;
  text-align: center;
  font-family: "OPPOSans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}
</style>